import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {getToken} from '@/utils/auth'

function getPageTitle(pageTitle) {
    const title = '洲远'
    if (pageTitle) {
        return `${title} - ${pageTitle}`
    }
    return `${title}`
}

NProgress.configure({showSpinner: false}) // NProgress Configuration

// 需要登录才能访问的后台管理路由
const adminRoutes = ['/maybe', '/password', '/info', '/products', '/addProduct', '/banner', '/carousel', '/pages', '/certificate']

router.beforeEach((to, from, next) => {
    NProgress.start()
    document.title = getPageTitle(to.meta.title)
    // 后台管理页面需要登录态；前台展示页面游客可自由访问
    if (adminRoutes.indexOf(to.path) !== -1 && !getToken()) {
        next('/login')
        NProgress.done()
    } else {
        next()
    }
})

router.afterEach(() => {
    NProgress.done()
})
